import { render, staticRenderFns } from "./manualBankInfor.vue?vue&type=template&id=052e8823&"
import script from "./manualBankInfor.vue?vue&type=script&lang=js&"
export * from "./manualBankInfor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports